import React from "react";
import PropTypes from "prop-types";
import { InputText, Label/* , Dropdown */ } from "../../../../components/Inputs";
import { /* STATUS_LABELS,  */STATUS_IDS } from "../../../../components/Utils";
import { RadioButton } from "primereact/radiobutton";

const WORKPLACE_LABELS = {
  GERMANY: "Deutschland",
  EUROPE: "Europa",
  OUTSIDE_EUROPE: "außerhalb Europa",
}

export default class ADConnectionForm extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    model: PropTypes.shape({
      adConnection: PropTypes.string,
      adUsername: PropTypes.string,
      adPassword: PropTypes.string,
      adCellNumber: PropTypes.string,
      vf_email: PropTypes.string,
      workplace: PropTypes.string,
      workplaceData: PropTypes.shape({
        name: PropTypes.string.isRequired,
        status_id: PropTypes.number.isRequired,
        action_id: PropTypes.number,
      }),
    }),
    readOnly: PropTypes.bool,
    vfEmailReadable: PropTypes.bool,
    vfEmailEditable: PropTypes.bool,
  };
  static defaultProps = {
    className: "",
    className: "",
    model: {
      adConnection: "Ja",
      adUsername: "",
      adPassword: "",
      adCellNumber: "",
      workplace: "",
      workplaceData: {
        name: "",
        action_id: 0,
        status_id: STATUS_IDS.NEW,
      }
    },
  };
  constructor(props) {
    super(props);
    this.state = this.generateState(props);
  }
  componentWillReceiveProps(props) {
    this.setState(this.generateState(props));
  }
  generateState(props) {
    const model = props.model || {};
    const adStatus_id =
      model.adStatus_id && model.adStatus_id !== ""
        ? model.adStatus_id
        : STATUS_IDS.NEW;
    return {
      adConnection: model.adConnection || "Ja",
      workplace: model.workplace || "",
      workplaceData: {
        name: "",
        action_id: 0,
        status_id: STATUS_IDS.NEW,
      },
      adCellNumber: model.adCellNumber || "",
      adStatus_id,
      error: {
        workplace: null,
      },
    };
  }
  getEmptyModel = () => {
    return {
      adConnection: "Ja",
      workplace: "",
      adCellNumber: "",
    };
  };
  validate = (initialize) => {
    const { error, ...model } = this.state;
    if (model.workplace === "") {
      this.setState({ error: { workplace: true } });
      return null;
    }
    if (initialize) {
      const state = this.getEmptyModel();
      this.setState(state);
    }
    return {
      ...this.props.model,
      ...model,
    };
  };
  getModel = (initialize = false) => {
    const model = this.validate(initialize);
    return model;
  };
  render() {
    const { className, model, disabled } = this.props;
    const { workplace, adCellNumber, adStatus_id, error } = this.state;
    return (
      <div className={className}>
        <div
          className={`form-group-item ${error.workplace ? "error-group" : ""}`}
        >
          <Label htmlFor="workplace">{`Arbeitsort*`}</Label>
          <WorkplaceRadioGroup
            className="pad-sm-top pad-btm"
            workplace={workplace}
            onChange={(value) => {
              this.setState(prev => ({
                workplace: value,
                workplaceData: {
                  ...prev.workplaceData,
                  name: value,
                },
                error: {
                  ...prev.error,
                  workplace: null
                }
              }));
            }}
            disabled={disabled}
          />
        </div>
        {(!model ||
          (model.adConnection === "" && adStatus_id === STATUS_IDS.NEW)) && (
          <div className="form-group-item pad-top-">
            <Label htmlFor="adCellNumber">{`optional: Handynummer zur Vorregistrierung des Authenticators`}</Label>
            <InputText
              id="adCellNumber"
              className="w3-block w3-border"
              value={adCellNumber}
              placeholder="+49XXX"
              onChange={(event) =>
                this.setState({ adCellNumber: event.target.value })
              }
            />
          </div>
        )}
      </div>
    );
  }
}


export const WorkplaceRadioGroup = ({ className, workplace, onChange, disabled, readonly}) => {
  const radioStyle = { display: "flex", alignItems: "center", gap: "4px" };
  const handleChange = (event) => {
    onChange && onChange(event.value);
  };
  if (readonly) {
    return (
      <div className="">
        <label className="p-checkbox-label">{workplace}</label>
      </div>
    );
  }
  return (
    <div className={`w3-row ${className}`}>
      {Object.entries(WORKPLACE_LABELS).map(([key, label], index) => (
        <div className="w3-col s4" key={key}>
          <div className="p-col-12" style={radioStyle}>
            <RadioButton
              inputId={`ch${index}`}
              name="workplace"
              value={label}
              checked={workplace === label}
              onChange={handleChange}
              disabled={disabled}
              className={disabled ? "p-disabled" : ""}
            />
            <label htmlFor={`ch${index}`} className="p-checkbox-label">
              {label}
            </label>
          </div>
        </div>
      ))}
    </div>
  );
}